import { useEffect, useState } from 'react';

import { UseFormReturn } from 'react-hook-form';

import { computeDurationOverflow, DurationOverflow } from '../helpers/format-time-track.helper';
import { TimeEntryFormValues } from '../schema';

export const useDurationOverflow = (form: UseFormReturn<TimeEntryFormValues>) => {
  const [durationOverflow, setDurationOverflow] = useState<DurationOverflow | null>(null);

  useEffect(() => {
    const subscription = form.watch((values, { name }) => {
      if (
        name !== 'startTime' &&
        name !== 'date' &&
        name !== 'duration.hours' &&
        name !== 'duration.minutes'
      )
        return;
      setDurationOverflow(
        computeDurationOverflow(
          values.startTime,
          values.date as Date | undefined,
          values.duration?.hours,
          values.duration?.minutes
        )
      );
    });

    return () => subscription.unsubscribe();
  }, [form]);

  const computeAndSet = (startTime?: string, date?: Date, hours?: number, minutes?: number) => {
    setDurationOverflow(computeDurationOverflow(startTime, date, hours, minutes));
  };

  return { durationOverflow, setDurationOverflow, computeAndSet };
};
